// console.log("[DEBUG...]: main.js loading");

document.addEventListener("readystatechange", (event) => {
	if (document.readyState === "complete") {
		// console.log("[DEBUG...]: main.js loaded");
		const getEnv = () => {
			let location, env;
			location = window.location.origin;
			if (location === "http://localhost:8888") {
				env = "localhost";
			} else if (location === "http://localhost") {
				env = "localhost";
			} else {
				env = "live";
			}
			return env;
		};
		const env = getEnv();

		// Hamburger & navigation toggle
		const nav = document.querySelector(".hidden-navigation-wrapper");
		const header = document.querySelector(".header-js-select");
		const login_menu = document.querySelector(".header-login-menu");
		const hamburger = document.getElementById("hamburger");
		const hamburger_text = document.getElementById("hamburger-text");
		const mainNavigation = document.getElementById("mainNavigation");
		const body = document.getElementsByTagName("BODY")[0];

		// Functions to add/remove classes to/from element
		//  (for example: addCSSclasses(target, "class-to-be-added, another-class"); )
		const addCSSclasses = (el, ...cls) =>
			cls.map((cl) => el.classList.add(cl));

		const removeCSSclasses = (el, ...cls) =>
			cls.map((cl) => el.classList.remove(cl));

		// Open menu
		const openMenu = () => {
			nav.removeAttribute("hidden");
			login_menu.setAttribute("hidden", "hidden");
			hamburger.classList.add("is-active", "hamburger-active");
			hamburger_text.textContent = "Close";
			addCSSclasses(body, "overflow-hidden");

			// Toggle classes on header
			addCSSclasses(header, "has-dark-blue-background-color");
			removeCSSclasses(header, "has-darkest-blue-background-color");

			// Listen for focus when nav is open
			document.addEventListener("focus", closeNavOffFocus, true);
		};

		const closeMenu = () => {
			nav.setAttribute("hidden", "hidden");
			login_menu.removeAttribute("hidden", "hidden");
			hamburger.classList.remove("is-active", "hamburger-active");
			hamburger_text.textContent = "Menu";
			removeCSSclasses(body, "overflow-hidden");

			// Toggle classes on header
			addCSSclasses(header, "has-darkest-blue-background-color");
			removeCSSclasses(header, "has-dark-blue-background-color");

			// Remove focus listener from document when nav closes
			document.removeEventListener("focus", closeNavOffFocus, true);
		};

		// If the focus is outside main navigation, close it
		const closeNavOffFocus = (e) => {
			let isClickInsideElement = mainNavigation.contains(e.target);

			if (!isClickInsideElement) {
				closeMenu();
			}
		};

		const toggleMenu = () => {
			if (nav.getAttribute("hidden") === "hidden") {
				// Open nav if it is closed
				openMenu();
			} else {
				closeMenu();
			}
		};

		hamburger.addEventListener("click", toggleMenu);

		// Pure JS Equaliser to balance out text/content boxes in a block (depending on the length of the content).
		const equaliser = (elsToEqualise) => {
			if (elsToEqualise.length > 0) {
				let highestEl = 0;
				// find highest element
				elsToEqualise.forEach((el) => {
					const elheight = el.clientHeight;
					if (elheight > highestEl) {
						highestEl = elheight;
					}
				});
				// set highest height to all the elements
				elsToEqualise.forEach((el) => {
					el.style.height = highestEl + "px";
				});
			}
		};

		const cards = document.querySelectorAll(
			".wp-blt-block-card__description > p"
		);
		equaliser(cards);
		const clickThroughBtns = document.querySelectorAll(
			".wp-blt-block-click-through-button__text"
		);

		equaliser(clickThroughBtns);

		// gravity forms
		const phoneField = document.querySelector("#input_3_23");
		if (phoneField) {
			phoneField.setAttribute("type", "number");
			phoneField.setAttribute("pattern", "[0-9]*");
			phoneField.setAttribute("inputmode", "numeric");
		}

		// Next Functions here
	}
});
